import axios from 'axios';
import { API_MYEDUZZ } from 'settings';

class BankAccountService {
  public getBankAccountByUuid = (uuid: string, token: string) => {
    return axios({
      baseURL: API_MYEDUZZ,
      url: `/fundtransfers/confirmation/${uuid}`,
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.data.data)
      .catch(error => {
        throw error;
      });
  };

  public confirmBankAccount = (uuid: string, token: string) => {
    return axios({
      baseURL: API_MYEDUZZ,
      url: `/fundtransfers/${uuid}/send-moderation`,
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.data.data)
      .catch(error => {
        throw error;
      });
  };
}

const service = new BankAccountService();

export default service;
